module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_cp_lp/november/mainvisual-bg-pc_ee2ebfdeefa0a6d775e55fc583e38027.png";